import React from 'react';
import { motion, Variants } from 'framer-motion';
import { Trans, useTranslation } from 'react-i18next'; 
import './ContactoPage.css';
import ContactButton from '../../atoms/ContactButton/ContactButton';
import contactoHero from '../../../assets/contactohero.png';

const ContactoPage: React.FC = () => {

  const { t } = useTranslation();

  const fadeInUp: Variants = {
    hidden: { opacity: 0, y: 40, scale: 0.98 },
    visible: { 
      opacity: 1, 
      y: 0, 
      scale: 1, 
      transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] } 
    },
  };

  return (
    <motion.div
      className="contact-page-container"
      initial="hidden"
      animate="visible"
      variants={fadeInUp}
    >
      {/* --- 1. Hero Section --- */}
      <header 
        className="contact-hero"
        style={{ backgroundImage: `url(${contactoHero})` }}
      >
        <div className="hero-overlay"></div>
        <h1 className="hero-title">
          <Trans i18nKey="contactPage:heroTitle" />
        </h1>
      </header>

      {/* --- 2. Título "Contáctanos" --- */}
      <section className="contact-title-bar">
        <h2 className="title-bar-text">
          <Trans i18nKey="contactPage:section.title" />
        </h2>
        <p className="title-bar-subtitle">
          <Trans i18nKey="contactPage:section.subtitle" />
        </p>
        <ContactButton to='mailto:info@villasflamingos.com'/>
      </section>

      {/* --- 3. Info y Mapa --- */}
      <section className="contact-info-map-section">
        <div className="info-map-grid">
          <div className="info-column">
            <div className="info-block">
              <a href="mailto:info@villasflamingos.com">info@villasflamingos.com</a>
            </div>
            <div className="info-block">
              <a href="tel:+529848752167">+52 984 875 2167</a>
            </div>
            <div className="info-block">
              <p>
                
                <Trans i18nKey="contactPage:address" />
              </p>
            </div>
          </div>
          <div className="map-column">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3711.368917510937!2d-87.36887282490453!3d21.532425480245955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85f10654abf05289%3A0x93d3b34ca61f38ff!2sHotel%20Villas%20Flamingos%20Holbox!5e0!3m2!1ses-419!2smx!4v1763783957823!5m2!1ses-419!2smx"
              width="100%"
              height="500"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={t('contactPage:mapTitle')}
            />
          </div>
        </div>
      </section>

      {/* --- 4. Únete al Equipo --- */}
      <section className="join-team-section">
        <h2 className="join-team-title">
          <Trans i18nKey="contactPage:joinTeam.title" />
        </h2>
        <p>
          <Trans 
            i18nKey="contactPage:joinTeam.description"
            components={{ strong: <strong /> }}
          />
        </p>
        <ContactButton to="mailto:rrhh@villasflamingos.com" />
      </section>
    </motion.div>
  );
};

export default ContactoPage;